<template>
	<div id="flights_table" style="position:relative;">
		<!-- ROOT TABLE (1. Layer - Flight Chain) -->
		<v-data-table
		v-if="showRotation"
			v-model="chains_selectedFlights"
			:headers="headers1"
			:items="get_FlightTable_Rotations_Chain_Filtered"
			:hide-default-footer="true"
			:sort-by="['children[0].children[0].leg.aircraft.code', 'date']"
			multi-sort
			item-key="id"
			:single-expand="true"
			show-expand
			show-select
			:single-select="false"
			:expanded.sync="expanded"
			:disable-pagination="true"
			:items-per-page="-1"
			class="flightsTable elevation-1 mb-0 mt-0 "
			color="primary"
			style="height:100%;"
			@click:row="onClick_flightsTableRow">
			<!-- >>> OpeningHours:Column -->
			<!-- :style="{backgroundColor: item.children[0].children[0].leg.deleted ? 'red': ''}" -->
			<template v-slot:item="{ item, expand, isExpanded }">
				<tr :class="{ deleted: item.children[0].children[0].leg.deleted !== null }"
					@mouseover="onHover_checkForValidSlotConnect(item, 'mouseover')"
					@mouseleave="onHover_checkForValidSlotConnect(item, 'mouseleave')"
					@click="onClick_flightsTableRow($event, item)">
					<td>
						<!-- TODO: check if color condition is needed -->
						<v-checkbox
							v-if="!chainIsExpanded"
							v-model="chains_selectedFlights"
							multiple
							:value="item"
							style="margin:0px;padding:0px;"
							hide-details />
					</td>
					<td>
						<span>
							{{ item.children.filter(child => child.type !== 'missingFlight').length }}
						</span>
					</td>
					<td>
						<span>
							<span>{{ $dayjsLocalToUTC(item.date, 'DD.MM.YYYY') }}</span>
							<span v-if="item.lastDate"> - {{ $dayjsLocalToUTC(item.lastDate, 'DD.MM.YYYY') }}</span>
						</span>
					</td>
					<td>
						<span>
							{{ $dayjsLocalToUTC(item.date, 'vt') }}
						</span>
					</td>
					<td>
						<div style="display:grid;grid-template-rows: 30px 30px;">
							<span>
								{{ item.children[0].children[0].leg.aircraft.code }}
							</span>
							<span :class="{'pt-4': $vuetify.breakpoint.lgAndDown}">
								{{ `${item.children[0].children[0].leg.aircraft.capacityY}Y / ${item.children[0].children[0].leg.aircraft.capacityC}C` }}
							</span>
						</div>
					</td>
					<td>
						<span>
							{{ item.rotationObject.flightNo }}
						</span>
					</td>
					<td>
						<div
							style="display:grid;grid-template-rows: 32px 32px;"
							:style="{gridTemplateColumns: item.rotationObject.gridTemplateColumns}">
							<span
								v-for="(route, i) in item.rotationObject.route" :key="i + route"
								style="height:100%;margin:0;margin-right:21px;display:flex;align-items:end;align-items:center;"
								:style="{justifyContent: route.justifyContent}"
								v-html="route.route" />
							<v-select
								v-for="(slotStatus, i) in item.rotationObject.slotStatus" :key="i"
								v-model="slotStatus.status"
								:disabled="!slotStatus.coordinated"
								style="height:100%;margin:0;margin-right:21px;display:flex;align-items:end;align-items:center;"
								:style="{justifyContent: slotStatus.justifyContent, backgroundColor: helper_getSlotRequestStatusColor(slotStatus)}"
								class="slotRequestStatus pa-0 ma-0 mr-2"
								:items="items_slotRequestStatus"
								:label="helper_getSlotRequestStatusSelectLabel(slotStatus)"
								hide-details
								single-line
								flat
								@change="onChange_slotStatus($event, slotStatus.flights)">
								{{ slotStatus.status }}
							</v-select>
						</div>
					</td>
					<td>
						<span>
							{{ item.rotationObject.flightModus }}
						</span>
					</td>
					<td v-if="item.children.length > 1 || item.children[0].children.length > 1">
						<v-tooltip
								v-for="(warning, index) in item.warnings"
								:key="index"
								top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									color="red"
									:style="{marginLeft: index !== 0 ? '14px' : ''}"
									v-bind="attrs"
									v-on="on">
									{{ warning.icon }}
								</v-icon>
							</template>
							<span>{{ warning.text }}</span>
						</v-tooltip>
					</td>
					<td v-else>
						<v-tooltip
								v-for="(warning, index) in item.children[0].children[0].warnings"
								:key="index"
								top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									color="red"
									:style="{marginLeft: index !== 0 ? '14px' : ''}"
									v-bind="attrs"
									v-on="on">
									{{ warning.icon }}
								</v-icon>
							</template>
							<span>{{ warning.text }}</span>
						</v-tooltip>
					</td>
					<td>
						<span v-if="!get_Shared_isUserAllowedToUse('READONLY')">
							<v-icon small class="mr-2" :class="get_ClassForEditedRow(item)" @click="onClick_flightsEdit($event, item)">
								mdi-pencil
							</v-icon>
							<v-icon
									:disabled="!(item.slotRequestsChain.find(slotRequest => slotRequest.some(sr => sr.airport.coordinated)))"
									small
									@click="onClick_openSlotRequestDialog($event, item)">
								mdi-send
							</v-icon>
						</span>
					</td>
					<td>
						<v-icon
							v-if="(item.children.length > 1 || item.children[0].children.length > 1)"
							class="pointer"
							@click="expandColumn($event, expand, isExpanded, 1);">
							{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
						</v-icon>
					</td>
				</tr>
			</template>

			<!-- >>> Expanded:Column -->
			<template v-slot:expanded-item="{ headers, item }">
				<!-- LAYER TABLE (2. Layer - Flight Rotation) -->
				<td
					v-if="(item.children.length > 1 || true)"
					:colspan="(headers2.length + 1)"
					style="padding:0 0 88px 0 !important;background-color:#edf4ed;">
					<div style="margin-left:22px;height:44px;border-left:1px solid black;position:sticky;top:0px;">
						<h2 style="margin-left: 22px;height:100%;display:flex;align-items:center;">
							Rotations
						</h2>
					</div>
					<div style="display:flex;">
						<div style="width:22px;" />
						<div style="width:22px;border-left:1px solid black;margin-bottom:75px;" :style="{ height: item.children.length === 1 ? '93px' : '' }" />
						<v-data-table
							v-model="rotations_selectedFlights"
							:headers="headers2"
							:items="item.children"
							:hide-default-footer="true"
							sort-by="date"
							item-key="id"
							:single-expand="true"
							show-expand
							show-select
							:single-select="false"
							:expanded.sync="expanded2"
							:disable-pagination="true"
							:items-per-page="-1"
							class="elevation-1 mb-0 mt-0 "
							color="primary"
							style="width:calc(100% - 44px);height:100%;">
							<template v-slot:item="{ item: item2, expand, isExpanded }">
								<tr
									style="position:relative;"
									:style="{ backgroundColor: item2.type === 'missingFlight' ? 'rgb(255 224 223)' : '' }">
									<td>
										<span
											style="position:absolute;width:22px;height:50%;border-bottom:1px solid black;left:-22px;top:0;"
											:style="{ height: item2.type === 'missingFlight' ? '33.5px' : '45px' }" />
										<v-checkbox
											v-if="(item2.type !== 'missingFlight')"
											v-model="rotations_selectedFlights"
											multiple
											:value="item2"
											style="margin:0px;padding:0px;"
											hide-details />
									</td>
									<td>
										<span />
									</td>
									<td>
										<span :style="{ fontWeight: item2.type === 'missingFlight' ? '400' : '' }">
											{{ item2.type === 'missingFlight' ? 'Missing Flight' : $dayjsLocalToUTC(item2.date, 'DD.MM.YYYY') }}
										</span>
									</td>
									<td>
										<span v-if="item2.type !== 'missingFlight'">
											{{ $dayjsLocalToUTC(item2.children[0].leg.departureTime, 'vt') }}
										</span>
									</td>
									<td>
										<div v-if="item2.type !== 'missingFlight'" style="display:grid;grid-template-rows: 30px 30px;">
											<span>
												{{ item2.children[0].leg.aircraft.code }}
											</span>
											<span>
												<!-- <v-icon color="#FFFF">$airplaneSeat</v-icon> -->
												{{ item2.children[0].leg.aircraft.capacityY }}Y / {{ item2.children[0].leg.aircraft.capacityC }}C
											</span>
										</div>
									</td>
									<td>
										<span v-if="item2.type !== 'missingFlight'">
											{{ item2.rotationObject.flightNo }}
										</span>
									</td>
									<td>
										<div
											v-if="item2.type !== 'missingFlight'"
											style="display:grid;grid-template-rows: 32px 32px;"
											:style="{gridTemplateColumns: item2.rotationObject.gridTemplateColumns}">
											<span
												v-for="(route, i) in item2.rotationObject.route" :key="i + route"
												style="height:100%;margin:0;margin-right:21px;display:flex;align-items:end;align-items:center;"
												:style="{justifyContent: route.justifyContent}"
												v-html="route.route" />
											<v-select
												v-for="(slotStatus, i) in item2.rotationObject.slotStatus" :key="i"
												v-model="slotStatus.status"
												:disabled="!slotStatus.coordinated"
												class="slotRequestStatus pa-0 ma-0 mr-2"
												style="height:100%;margin:0;margin-right:21px;display:flex;align-items:end;align-items:center;"
												:style="{justifyContent: slotStatus.justifyContent, backgroundColor: helper_getSlotRequestStatusColor(slotStatus)}"
												:items="items_slotRequestStatus"
												:label="helper_getSlotRequestStatusSelectLabel(slotStatus)"
												hide-details
												single-line
												flat
												@change="onChange_slotStatus($event, slotStatus.flights)">
												{{ slotStatus.status }}
											</v-select>
										</div>
									</td>
									<td>
										<span v-if="item2.type !== 'missingFlight'">
											{{ item2.rotationObject.flightModus }}
										</span>
									</td>
									<td v-if="item2.children.length > 1 || item2.type === 'missingFlight'">
										<v-tooltip
											v-for="(warning, index) in item2.warnings"
											:key="index"
											top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon
													color="red"
													:style="{marginLeft: index !== 0 ? '14px' : ''}"
													v-bind="attrs"
													v-on="on">
													{{ warning.icon }}
												</v-icon>
											</template>
											<span>{{ warning.text }}</span>
										</v-tooltip>
									</td>
									<td v-else>
										<v-tooltip
											v-for="(warning, index) in item2.children[0].warnings"
											:key="index"
											top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon
													color="red"
													:style="{marginLeft: index !== 0 ? '14px' : ''}"
													v-bind="attrs"
													v-on="on">
													{{ warning.icon }}
												</v-icon>
											</template>
											<span>{{ warning.text }}</span>
										</v-tooltip>
									</td>
									<td>
										<span v-if="item2.type !== 'missingFlight' && !get_Shared_isUserAllowedToUse('READONLY')" style="margin-left: 15px;">
											<v-icon small class="mr-2" :class="get_ClassForEditedRow(item2)" @click="onClick_flightsEdit($event, item2)">
												mdi-pencil
											</v-icon>
											<v-icon :disabled="!(item2.slotRequestsRotation.some(sr => sr.airport.coordinated))"
													small class="ml-2"
													@click="onClick_openSlotRequestDialog($event, item2)">
												mdi-send
											</v-icon>
										</span>
									</td>
									<td>
										<v-icon
											v-if="item2.type !== 'missingFlight' && item2.children.length > 1"
											class="pointer"
											@click="expandColumn($event, expand, isExpanded, 2);">
											{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
										</v-icon>
									</td>
								</tr>
							</template>
							<template v-slot:expanded-item="{ headers, item }">
								<!-- LAYER TABLE (3. Layer - Flight Leg) -->
								<td
									v-if="item.children.length > 1"
									:colspan="headers3.length + 3"
									style="padding:0 0 44px 0 !important;background-color:#f4e1e1;">
									<div style="margin-left:22px;height:44px;border-left:1px solid black;">
										<h2 style="margin-left: 22px;height:100%;display:flex;align-items:center;">
											Single Legs
										</h2>
									</div>
									<div style="display:flex;">
										<div style="width:22px;" />
										<div style="width:22px;border-left:1px solid black;margin-bottom:71px;" />
										<v-data-table
											v-model="legs_selectedFlights"
											:headers="headers3"
											:items="item.children"
											:hide-default-footer="true"
											sort-by="date"
											item-key="id"
											:disable-pagination="true"
											:items-per-page="-1"
											class="elevation-1 mb-0 mt-0 "
											color="primary"
											style="width:calc(100% - 44px);height:100%;"
											@click:row="onClick_flightsTableRow">
											<!-- >>> OpeningHours:Column -->
											<template v-slot:item="{ item, expand, isExpanded }">
													<tr
														style="position:relative;"
														@mouseover="onHover_checkForValidSlotConnect(item, 'mouseover')"
														@mouseleave="onHover_checkForValidSlotConnect(item, 'mouseleave')"
														@click="onClick_flightsTableRow($event, item)">
														<td>
															<span style="position:absolute;width:22px;height:45px;border-bottom:1px solid black;left:-22px;top:0;" />
															<!-- <v-checkbox
																v-model="legs_selectedFlights"
																multiple
																:value="item"
																style="margin:0px;padding:0px"
																hide-details /> -->
														</td>
														<td>
															<span>
																{{ $dayjsLocalToUTC(item.leg.dep_sch_time, 'DD.MM.YYYY') }}
															</span>
														</td>
														<td>
															<span>
																{{ $dayjsLocalToUTC(item.leg.dep_sch_time, 'vt') }}
															</span>
														</td>
														<td>
															<div v-if="item.type !== 'missingFlight'" style="display:grid;grid-template-rows: 30px 30px;">
																<span>
																	{{ item.leg.aircraft.code }}
																</span>
																<span>
																	<!-- <v-icon color="#FFFF">$airplaneSeat</v-icon> -->
																	{{ item.leg.aircraft.capacityY }}Y / {{ item.leg.aircraft.capacityC }}C
																</span>
															</div>
														</td>
														<td>
															<span v-if="item.type !== 'missingFlight'">
																{{ item.leg.flightNo }}
															</span>
														</td>
														<td>
															<div style="display:grid;grid-template-columns: 88px 88px;grid-template-rows: 30px 30px;">
																<span style="margin-right:21px;display:flex;align-items:center;">
																	{{ item.leg.aptFrom.aptCode }}{{ $dayjsLocalToUTC(item.leg.dep_sch_time, 'HHmm') }}
																</span>
																<span style="margin-right:21px;display:flex;align-items:center;justify-content:end;">
																	{{ $dayjsLocalToUTC(item.leg.arr_sch_time, 'HHmm') }}{{ item.leg.aptTo.aptCode }}
																</span>

																<span style="margin-right:21px;display:flex;align-items:center;">
																	{{ item.leg.aptFrom.aptCode }}<span v-html="helper_getSlotInfo(item.leg.aptFrom, item.leg.dep_sch_time, item.leg.dep_slt_time)" />
																</span>
																<span style="margin-right:21px;display:flex;align-items:center;justify-content:end;">
																	<span v-html="helper_getSlotInfo(item.leg.aptTo, item.leg.arr_sch_time, item.leg.arr_slt_time)" />{{ item.leg.aptTo.aptCode }}
																</span>

																<div>
																	<v-select
																		v-model="item.leg.depSlotStatus"
																		:disabled="!item.leg.aptFrom.coordinated"
																		class="slotRequestStatus pa-0 ma-0 mr-2"
																		:style="{backgroundColor: helper_getSlotRequestStatusColor({coordinated: item.leg.aptFrom.coordinated, status: item.leg.depSlotStatus, isDifferentStatus: true })}"
																		:items="items_slotRequestStatus"
																		label=""
																		hide-details
																		single-line
																		flat
																		@change="onChange_slotStatus($event, [{field: 'depSlotStatus', flight: item.leg}])">
																		{{ item.leg.depSlotStatus }}
																	</v-select>
																</div>
																<div>
																	<v-select
																		v-model="item.leg.arrSlotStatus"
																		:disabled="!item.leg.aptTo.coordinated"
																		class="slotRequestStatus pa-0 ma-0 mr-2"
																		:style="{backgroundColor: helper_getSlotRequestStatusColor({coordinated: item.leg.aptTo.coordinated, status: item.leg.arrSlotStatus, isDifferentStatus: true })}"
																		:items="items_slotRequestStatus"
																		label=""
																		hide-details
																		single-line
																		flat
																		@change="onChange_slotStatus($event, [{field: 'arrSlotStatus', flight: item.leg}])">
																		{{ item.leg.arrSlotStatus }}
																	</v-select>
																</div>
															</div>
														</td>
														<td>
															<span>
																{{ item.leg.mainServiceType }}
															</span>
														</td>
														<td>
															<v-tooltip
																v-for="(warning, index) in item.warnings"
																:key="index"
																top>
																<template v-slot:activator="{ on, attrs }">
																	<v-icon
																		color="red"
																		:style="{marginLeft: index !== 0 ? '14px' : ''}"
																		v-bind="attrs"
																		v-on="on">
																		{{ warning.icon }}
																	</v-icon>
																</template>
																<span>{{ warning.text }}</span>
															</v-tooltip>
														</td>
														<!-- <td>
															<v-chip-group v-if="item.type !== 'missingFlight'">
																<v-chip>
																	REQUESTED
																</v-chip>
															</v-chip-group>
														</td> -->
														<td style="z-index: 10">
															<!-- <span v-if="get_Shared_isUserAllowedToUse('ADMIN') === true" style="margin-left: 15px;">
																<v-icon small class="mr-2" :class="get_ClassForEditedRow(item)" @click="onClick_flightsEdit($event, item)">
																	mdi-pencil
																</v-icon>
																<v-icon small class="ml-2" @click="onClick_openSlotRequestDialog(item)">
																	mdi-send
																</v-icon>
															</span> -->
														</td>
													</tr>
											</template>
										</v-data-table>
									</div>
								</td>
								<!-- LAYER TABLE (3. Layer - Flight Leg) -->
							</template>
						</v-data-table>
					</div>
				</td>
				<!-- LAYER TABLE (2. Layer - Flight Rotation) -->
			</template>
			<!-- <<< Expanded:Column -->
		</v-data-table>
		<!-- ROOT TABLE (1. Layer - Flight Chain) -->

		<!-- >>> Sdr-Component, BottomSheet -->
		<sdr-slotmanagement-bottom-sheet-update
			v-if="showSheet2"
			v-model="showSheet2"
			:editorMode="editorMode2"
			:selectedFlights="selectedFlights"
			:selectedLayer="selectedLayer" />
		<!-- <<< Sdr-Component, BottomSheet -->

		<!-- >>> Sdr-Component, Slot Request Dialog -->
		<sdr-slotmanagement-slot-request-dialog
			v-if="showSlotRequestDialog"
			v-model="showSlotRequestDialog"
			:flights="selectedFlights"
			:selectedLayer="selectedLayer"
			:modus="slotRequestModus"
			:get-class-for-edited-row="get_ClassForEditedRow"
			:smallScreen="smallScreen" />
		<!-- <<< Sdr-Component, Slot Request Dialog -->

		<!-- <<< Sdr-Component, Dialog - Slottransfer -->
		<v-dialog v-if="slotConnectionDialogShown" v-model="slotConnectionDialogShown" scrollable style="min-height:600px;" width="50vw">
			<v-card ref="card">
				<v-card-title class="mb-5 mt-7" style="font-size:1.3rem;">
					Slot Transfer
				</v-card-title>

                <v-card-text class="mt-3">
                    <v-form ref="form" v-model="slotConnectionValid" lazy-validation>
                        <v-container>
							<div style="text-align:center;">
								Do you want to transfer the slot?
							</div>
							<v-col>
								<v-row style="display:flex;justify-content:center;">
									<v-col cols="5" md="2" style="border-bottom:1px solid #ededed;border-right:1px solid #ededed;" />
									<v-col cols="4" md="2" style="border-bottom:1px solid #ededed;">
										Flight
									</v-col>
									<v-col cols="4" md="2" style="border-bottom:1px solid #ededed;">
										Slot
									</v-col>
								</v-row>
								<v-row style="display:flex;justify-content:center;">
									<v-col cols="4" md="2" style="border-right:1px solid #ededed;">
										FlightNo.
									</v-col>
									<v-col cols="4" md="2">
										{{ flight.flightNo }}
									</v-col>
									<v-col cols="4" md="2" :style="{color: !slotFlightCompatibility.flightNoCompatible ? 'red' : ''}">
										{{ slot.flightNo }}
									</v-col>
								</v-row>
								<v-row style="display:flex;justify-content:center;">
									<v-col cols="4" md="2" style=";border-right:1px solid #ededed;">
										Airport
									</v-col>
									<v-col cols="4" md="2">
										{{ slotDirection === 'departure' ? flight.aptTo.aptCode : flight.aptFrom.aptCode }}
									</v-col>
									<v-col cols="4" md="2" :style="{color: !slotFlightCompatibility.airportCompatible ? 'red' : ''}">
										{{ slot.airport }}
									</v-col>
								</v-row>
								<v-row style="display:flex;justify-content:center;">
									<v-col cols="4" md="2" style="border-right:1px solid #ededed;">
										Time
									</v-col>
									<v-col cols="4" md="2">
										{{ slotDirection === 'departure' ? $dayjsLocalToUTC(flight.dep_sch_time, 'HH:mm') : $dayjsLocalToUTC(flight.arr_sch_time, 'HH:mm') }}
									</v-col>
									<v-col cols="4" md="2" :style="{color: !slotFlightCompatibility.timeCompatible ? 'red' : ''}">
										{{ $dayjsLocalToUTC(slot.slotTime, 'HH:mm') }}
									</v-col>
								</v-row>
								<v-row style="display:flex;justify-content:center;">
									<v-col cols="4" md="2" style="border-right:1px solid #ededed;">
										Type
									</v-col>
									<v-col cols="4" md="2">
										{{ flight.flightType }}
									</v-col>
									<v-col cols="4" md="2" :style="{color: !slotFlightCompatibility.flightTypeCompatible ? 'red' : ''}">
										{{ slot.flightType }}
									</v-col>
								</v-row>
								<v-row style="display:flex;justify-content:center;margin:12px 0px;">
									<v-btn @click="onClick_openSlotRequestDialogForSlot">
										Open Slot Request Terminal
									</v-btn>
								</v-row>
							</v-col>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions>
                    <v-spacer />
					<v-btn outlined color="#ab3b7a" @click="slotConnectionDialogShown = false">
						Close
					</v-btn>
                    <v-btn color="primary" @click="onClick_transferSlot">
						Transfer
					</v-btn>
                </v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <<< Sdr-Component, Dialog - Slottransfer -->
	</div>
</template>

<script>
	import Vue from 'vue';
	import { mapActions, mapGetters } from 'vuex';
	import { eventBus } from '../../../../../../main';

	import dayjs from 'dayjs';
	import SlotRequestDialog from '../../shared/SlotRequestDialog.vue';

	import BottomSheetUpdate from './BottomSheet/BottomSheetUpdate.vue';


    export default {
        name: 'Blocktimes',


		/* >>> *************************************************************** / /* Components */
		components: {

			'sdr-slotmanagement-slot-request-dialog': SlotRequestDialog,
			'sdr-slotmanagement-bottom-sheet-update': BottomSheetUpdate

		}, // eo components{}
		/* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Props */
        props: {

			smallScreen: Boolean,
			showRotation: Boolean

        }, // eo props{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				flights: [],
				// >>> Data Table Header ------------------
				headers1: [
					{ text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
					{ text: 'Flights', value: '', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Date', value: 'date', class: 'sticky-header grey lighten-3' },
					{ text: 'DOW', value: 'vt', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'AC / Seats', value: 'children[0].children[0].leg.aircraft.code', class: 'sticky-header grey lighten-3' },
					{ text: 'Flight No.', value: 'children[0].children[0].children.flightNo', class: 'sticky-header grey lighten-3' },
					{ text: 'Schedule / Slot / Request Status', sortable: false, value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Service Type', value: 'children[0].children[0].children.mainServiceType', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Warnings', value: '', sortable: false, class: 'sticky-header grey lighten-3' },
					// { text: 'Slot Request Status', value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' }
				],
				headers2: [
					{ text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
					{ text: '', value: '', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Date', value: 'children[0].children.departureTime', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'DOW', value: 'vt', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'AC / Seats', value: 'children[0].children.aircraft.code', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Flight No.', value: 'children[0].children.flightNo', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Schedule / Slot / Request Status', sortable: false, value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Service Type', value: 'children[0].children.mainServiceType', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'Warnings', value: '', sortable: false, class: 'sticky-header grey lighten-3' },
					// { text: 'Slot Request Status', value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' }
				],
				headers3: [
					{ text: '', value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Date', value: 'children[0].children.departureTime', class: 'sticky-header grey lighten-3' },
					{ text: 'DOW', value: 'vt', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: 'AC / Seats', value: 'children[0].children.aircraft.code', class: 'sticky-header grey lighten-3' },
					{ text: 'Flight No.', value: 'children[0].children.flightNo', class: 'sticky-header grey lighten-3' },
					{ text: 'Schedule / Slot / Request Status', sortable: false, value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Service Type', value: 'children[0].children.mainServiceType', class: 'sticky-header grey lighten-3' },
					// { text: 'Slot Request Status', value: '', class: 'sticky-header grey lighten-3' },
					{ text: 'Warnings', value: '', sortable: false, class: 'sticky-header grey lighten-3' },
					// { text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'acions', sortable: false, class: 'sticky-header grey lighten-3' }
				],
				// >>> ------------------------------------
				chains_selectedFlights: [],
				rotations_selectedFlights: [],
				legs_selectedFlights: [],
				// >>> ------------------------------------
				expanded: [],
				expanded2: [],
				singleExpand: true,
				chainIsExpanded: false,
				selectedLayer: '',
                // >>> ------------------------------------ Tables Checkboxes
                singleSelect: false,
                dataTable_selected: [],
				// >>> ------------------------------------ Bottom Sheet
				selectedFlights: null,
				showSheet2: false,
				editorMode2: '',
				// >>> ------------------------------------ Dialog
				showConfirmDeleteDialog: false,
				resourceIdToDelete: null,
				// >>> ------------------------------------ Slot Request
				showSlotRequestDialog: false,
				slotRequestModus: '',
				// >>> ------------------------------------ Slot Connection
				conntectingSlot: null,
				slot: null,
				flight: null,
				slotConnectionDialogShown: false,
				slotConnectionValid: false,
				slotDirection: '',
				slotFlightCompatibility: {
					flightNoCompatible: false,
					airportCompatible: false,
					timeCompatible: false,
					flightTypeCompatible: false
				},
				selected: [],
				slotRequestStatus: {},
				items_slotRequestStatus: [
					{
						value: 'confirmed',
						text: 'Confirmed'
					},
					{
						value: 'pending',
						text: 'Pending'
					},
					{
						value: 'offered',
						text: 'Offered'
					},
					{
						value: 'refused',
						text: 'Refused'
					},
					{
						value: 'cancelled',
						text: 'Cancelled'
					}
				]

			};

		}, // eo function data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Flights_Filtered',
				'get_flights_Events',
				'get_Shared_isUserAllowedToUse',
				'get_AircraftConfigs',
				'get_Airports',
				'get_FlightTable_SelectedFlights',
				'get_FlightTable_Rotations_Chain_Filtered'
			]),

			slotRequestStatusColor: {
				get () {
					return this.slotRequestStatus.color;
				},
				set (value) {
					this.slotRequestStatus.color = value;
				}
			}

		}, // eo function destroyed()
		/* <<< ****************************************************************/

		/* >>> *************************************************************** / /* watch */
        watch: {

			/*******************************************************************
            * dataTable_selected{}
            *
            * Desc:
            * Note:
            *
            */
			dataTable_selected (val, oldVal) {

				const me = this;


				me.$toc('>>> views/flights/slotmanagement/components/core/FlightsTable.vue >>> watch > dataTable_selected');
				me.actn_set_flightTable_selectedFlights(val);

			} // eo function dataTable_selected()

        }, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

			const me = this;


			me.$toc('>>> views/flights/slotmanagement/components/core/FlightsTable.vue >>> created');
			eventBus.$on('flightsEditClicked', me.onEmit_flightsEdit);
			eventBus.$on('flightsSlotRequestClicked', me.onEmit_openSlotRequestDialog);
			eventBus.$on('selectedconntectslot', me.onEmit_connectSlot);
			//me.onCreate_setInitialStates();

		}, // eo function created()
		/* <<< ****************************************************************/

		/***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

			const me = this;


			me.$toc('>>> views/flights/slotmanagement/components/core/FlightsTable.vue >>> destroyed');
			me.actn_set_flightTable_selectedFlights([]);
			eventBus.$off('flightsEditClicked', me.onEmit_flightsEdit);
			eventBus.$off('flightsSlotRequestClicked', me.onEmit_openSlotRequestDialog);
			eventBus.$off('selectedconntectslot', me.onEmit_connectSlot);

		}, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_getFlights',
				'actn_set_filterFlights_filterTerm',
				'actn_set_flightTable_selectedFlights',
				'actn_call_slotmanagement_updateFlights'
			]),


			/******************************************************************* 'Listeners -  Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
			* onEmit_flightsEdit()
			*
			* Desc: TODO:
			* Note:
			*
			*/
			onEmit_flightsEdit: function() {

				const me = this;


				me.$toc('>>> views/flights/slotmanagement/components/core/FlightsTable.vue >>> onEmit_flightsEdit');
				if (me.chains_selectedFlights.length > 0) {
					me.selectedLayer = 1;
					me.selectedFlights = me.chains_selectedFlights;
					me.editorMode2 = 'update';
					me.showSheet2 = true;
				} else if (me.rotations_selectedFlights.length > 0) {
					me.selectedLayer = 2;
					me.selectedFlights = me.rotations_selectedFlights;
					me.editorMode2 = 'update';
					me.showSheet2 = true;
				}


			}, // eo function onEmit_flightsEdit()


			/*******************************************************************
			* onClick_flightsEdit()
			*
			* Desc: Event: dbclick:row => Sets Resource Item. Set Mode 'update'.
			* Note: Opens Bottom Sheet too.
			*
			*/
			onClick_flightsEdit: function(event, resourceItem) {

				const me = this;



				me.$toc('>>> views/flights/slotmanagement/components/core/FlightsTable.vue >>> onClick_flightsEdit');
				event.stopPropagation();
				me.chains_selectedFlights = [];
				me.rotations_selectedFlights = [];
				me.legs_selectedFlights = [];

				if (resourceItem.layer === 1) {
					me.chains_selectedFlights.push(resourceItem);
				} else if (resourceItem.layer === 2) {
					me.rotations_selectedFlights.push(resourceItem);
				}

				if (me.chains_selectedFlights.length > 0) {
					me.selectedLayer = 1;
					me.selectedFlights = me.chains_selectedFlights;
					me.editorMode2 = 'update';
					me.showSheet2 = true;
				} else if (me.rotations_selectedFlights.length > 0) {
					me.selectedLayer = 2;
					me.selectedFlights = me.rotations_selectedFlights;
					me.editorMode2 = 'update';
					me.showSheet2 = true;
				}

			}, // eo function onClick_flightsEdit()

			/*******************************************************************
            * onClick_openSlotRequestDialog()
            *
            * Desc: Triggers Call to search Flights
            * Note:
            *
            */
			onClick_openSlotRequestDialog: function(event, flight) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onClick_openSlotRequestDialog');
				event.stopPropagation();
				me.chains_selectedFlights = [];
				me.rotations_selectedFlights = [];
				me.legs_selectedFlights = [];

				if (flight.layer === 1) {
					me.chains_selectedFlights.push(flight);
				} else if (flight.layer === 2) {
					me.rotations_selectedFlights.push(flight);
				}

				me.slotRequestModus = 'flight';
				me.selectedFlights = [flight];
				me.selectedLayer = flight.layer;
				me.showSlotRequestDialog = true;

			}, // eo function onClick_openSlotRequestDialog()

			/*******************************************************************
            * onEmit_openSlotRequestDialog()
            *
            * Desc: Triggers Call to search Flights
            * Note:
            *
            */
			onEmit_openSlotRequestDialog: function() {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onEmit_openSlotRequestDialog');
				if (me.chains_selectedFlights.length > 0) {
					me.selectedLayer = 1;
					me.selectedFlights = me.chains_selectedFlights;
				} else if (me.rotations_selectedFlights.length > 0) {
					me.selectedLayer = 2;
					me.selectedFlights = me.rotations_selectedFlights;
				}
				me.slotRequestModus = 'flight';
				me.showSlotRequestDialog = true;

			}, // eo function onEmit_openSlotRequestDialog()

			/*******************************************************************
            * onClick_flightsTableRow{}
            *
            * Desc:
            * Note:
            *
            */
			onClick_flightsTableRow: function(event, flight) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onClick_flightsTableRow');
				if (me.conntectingSlot && me.slotConnectionValidation(flight, me.conntectingSlot)) {
					me.dataTable_selected = [flight];
					me.children = flight;
					me.slot = me.conntectingSlot;
					eventBus.$emit('clearconnectingslot', me.conntectingSlot);
					me.checkSlotFlightCompatibility(flight, me.slot);
					me.slotConnectionDialogShown = true;

				}
			}, // eo function onClick_flightsTableRow()

			/*******************************************************************
            * onEmit_connectSlot{}
            *
            * Desc:
            * Note:
            *
            */
			onEmit_connectSlot: function(slot) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onEmit_connectSlot');
				me.conntectingSlot = slot;
				// reset
				if (slot === null) {
					me.get_Flights_Filtered.forEach(f => {
						document.getElementById(f.idFlight).classList.remove('notConnectable');
						document.getElementById(f.idFlight).classList.remove('connectable');
					});
				}

			}, // eo function onClick_flightsTableRow()

			/*******************************************************************
            * onHover_checkForValidSlotConnect{}
            *
            * Desc:
            * Note:
            *
            */
			onHover_checkForValidSlotConnect: function(flight, position) {

				const me = this;


				if (flight && me.conntectingSlot) {
					me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onHover_checkForValidSlotConnect');
					if (position === 'mouseover') {

						if (me.slotConnectionValidation(flight, me.conntectingSlot)) {
							document.getElementById(flight.idFlight).classList.add('connectable');
						} else {
							document.getElementById(flight.idFlight).classList.add('notConnectable');
						}

					} else if (position === 'mouseleave') {
						document.getElementById(flight.idFlight).classList.remove('notConnectable');
						document.getElementById(flight.idFlight).classList.remove('connectable');
					}

				}
			}, // eo function onHover_checkForValidSlotConnect()

			/*******************************************************************
            * slotConnectionValidation{}
            *
            * Desc:
            * Note:
            *
            */
			slotConnectionValidation: function(flight, slot) {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> slotConnectionValidation');
				if (slot.direction === 'DEPARTURE' && flight.aptFrom.aptCode === slot.airportSlot) {
					me.slotDirection = 'departure';
					if (dayjs(flight.dep_sch_time).isSame(dayjs(slot.slotTime), 'date')) {
						return true;
					}

				}
				if (slot.direction === 'ARRIVAL' && flight.aptTo.aptCode === slot.airportSlot) {
					me.slotDirection = 'arrival';
					if (dayjs(flight.arr_sch_time).isSame(dayjs(slot.slotTime), 'date')) {
						return true;
					}

				}

			}, // eo function slotConnectionValidation()

			/*******************************************************************
            * checkSlotFlightCompatibility{}
            *
            * Desc:
            * Note:
            *
            */
			checkSlotFlightCompatibility: function(flight, slot) {

				const me = this;
				const tmp_slotFlightCompatibility = {
					flightNoCompatible: false,
					airportCompatible: false,
					timeCompatible: false,
					flightTypeCompatible: false
				};


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> slotConnectionValidation');
				if (flight.flightNo === slot.flightNo) {
					tmp_slotFlightCompatibility.flightNoCompatible = true;
				}
				if (slot.direction === 'DEPARTURE') {
					if (flight.aptTo.aptCode === slot.airport) {
						tmp_slotFlightCompatibility.airportCompatible = true;
					}
				} else {
					if (flight.aptFrom.aptCode === slot.airport) {
						tmp_slotFlightCompatibility.airportCompatible = true;
					}
				}
				if (dayjs(flight.dep_sch_time).isSame(dayjs(slot.slotTime))) {
					tmp_slotFlightCompatibility.timeCompatible = true;
				}
				if (flight.flightType === slot.flightType) {
					tmp_slotFlightCompatibility.flightTypeCompatible = true;
				}

				me.slotFlightCompatibility = tmp_slotFlightCompatibility;


			}, // eo function checkSlotFlightCompatibility()

			/*******************************************************************
            * onClick_transferSlot()
            *
            * Desc:
            * Note:
            *
            */
			onClick_transferSlot: function() {

				const me = this;


				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onClick_transferSlot');
				me.slotConnectionDialogShown = false;
				me.updateFlights(me.children, me.slot);

			}, // eo function onClick_transferSlot()

			/*******************************************************************
            * onClick_openSlotRequestDialogForSlot()
            *
            * Desc:
            * Note:
            *
            */
			onClick_openSlotRequestDialogForSlot: function() {

				const me = this;
				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onClick_openSlotRequestDialogForSlot');
				me.slot.dep_sch_time = me.children.dep_sch_time;
				me.slot.arr_sch_time = me.children.arr_sch_time;
				eventBus.$emit('openslotrequestdialogforslot', [me.slot]);

			}, // eo function onClick_openSlotRequestDialogForSlot()

			/*******************************************************************
			* onChange_slotStatus()
			*
			* Desc:
			* Note:
			*
			*/
			onChange_slotStatus: function (event, flights) {

				const me = this,
					payload = { flights: [] };
				me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> onChange_slotStatus');
				flights.forEach(flight => {
					flight.flight[flight.field] = event; // update slot status of flight object
					payload.flights.push(Vue.prototype.$buildFlightUpdatePayload(flight.flight));
				});
				me.actn_call_slotmanagement_updateFlights(payload);

			}, // eo function onChange_slotStatus()

			/*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ClassForSlotWarning{}
            *
            * Desc:
            * Note:
            *
            */
            get_ClassForSlotWarning: function(airport, slot, scheduled) {

                const me = this;
                let warning = false;

                // me.$toc('>>> views/slotmanagement/componentens/core/FlightsTable.vue >>> get_ClassForSlotWarning');
                if (!Vue.prototype.$isEmpty(airport) && airport.coordinated) {

                    if (!Vue.prototype.$isEmpty(scheduled) && !Vue.prototype.$isEmpty(slot)) {
                        const [schedule_HH, schedule_mm] = dayjs(scheduled).format('HH:mm').split(':');
                        const [slot_HH, slot_mm] = dayjs(slot).format('HH:mm').split(':');
                        const slotScheduleTimeDiff = Math.abs(dayjs().hour(schedule_HH).minute(schedule_mm).diff(dayjs().hour(slot_HH).minute(slot_mm), 'minute'));

                        if (slotScheduleTimeDiff > 15) {

                            warning = true;
                        }
                    }
                }


                return warning;

            }, // eo function get_ClassForSlotWarning{}
            /*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                const me = this;


				// me.$toc('>>> views/flights/slotmanagement/FlightsTable.vue >>> get_ClassForEditedRow');
				return item.wasEdited === true ? 'rowWasEdited' : '';

			}, // eo function get_ClassForEditedRow()

			/*******************************************************************
            * set_chipColor()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			set_chipColor: function(slotStatus) {

                const me = this;
				let color = '';


				// me.$toc('>>> views/flights/slotmanagement/FlightsTable >>> set_chipColor');
				if (slotStatus === 'OPEN' || Vue.prototype.$isEmpty(slotStatus)) {
					color = '#ab3b7a';
				} else if (slotStatus === 'PENDING') {
					color = 'rgb(208 208 84)';
				} else {
					color = 'green';
				}

				return color;

			}, // eo function set_chipColor()

			/*******************************************************************
			* helper_getSlotInfo()
			*
			* Desc: Checks if Slot is needed and mismatching slot
            * Note:
            *
			*/
			helper_getSlotInfo: function (apt, scheduled, slot) {

				let color = 'black',
					time = '';

				if (apt.coordinated) {
					if (Vue.prototype.$isMismatchingSlot(scheduled, slot)) {
						color = 'red';
					}
					if (!slot) {
						time = 'XXXX';
					} else {
						time = Vue.prototype.$dayjsLocalToUTC(slot, 'HHmm');
					}

					return `<span style="color:${color}">${time}</span>`;
				} else {

					return '';
				}
			}, // eo function helper_getSlotInfo()

			/*******************************************************************
			* helper_getSlotRequestStatusColor()
			*
			* Desc:
            * Note:
            *
			*/
			helper_getSlotRequestStatusColor: function (slotRequestStatus) {

				let color = '';

				if (slotRequestStatus.coordinated && !slotRequestStatus.isDifferentStatus) {
					if (slotRequestStatus.status === 'confirmed' || slotRequestStatus.status === 'cancelled') {
						color = '#F5F8F2';	// Baby powder
					} else if (slotRequestStatus.status === 'pending' || slotRequestStatus.status === 'offered') {
						color = '#FCF8EE';	// Floral white
					} else if (slotRequestStatus.status === 'refused') {
						color = '#FFEBEB';	// Misty rose
					}
				}

				return color;
			}, // eo function helper_getSlotRequestStatusColor()

			/*******************************************************************
			* helper_getSlotRequestStatusSelectLabel()
			*
			* Desc:
            * Note:
            *
			*/
			helper_getSlotRequestStatusSelectLabel: function (slotRequestStatus) {

				let label = '';

				if (slotRequestStatus.coordinated) {
					if (slotRequestStatus.isDifferentStatus) {
						label = '***';
					} else {
						label = '';
					}
				} else {
					label = '';
				}

				return label;

			}, // eo function helper_getSlotRequestStatusSelectLabel()

			/*******************************************************************
			* expandColumn()
			*
			* Desc:
            * Note:
            *
			*/
			expandColumn: function(event, expandFunction, expanded, layer) {

				const me = this;


				event.stopPropagation();
				expandFunction(!expanded);
				me.chains_selectedFlights = [];
				me.rotations_selectedFlights = [];

				if (layer === 1 && !expanded) {
					me.chainIsExpanded = true;
				} else if (layer === 1 && expanded) {
					me.chainIsExpanded = false;
				}
			} // eo function expandColumn()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>


<style scoped>

	.flightsTable >>> tbody tr:hover {
        background-color: #ab3b7b1b !important;
     }

	.flightsTable >>> tbody .deleted {
		background-color: rgb(255, 244, 244);
	}

	.slotRequestStatus >>> .v-select__selection {
		text-transform: none;
		color: rgba(0, 0, 0, 0.87);
		font-weight: 300;
		font-size: 0.875rem;
		max-width: 100%;
		margin: 0px;
	}

	.slotRequestStatus >>> label {
		font-size: 0.875rem;
		font-weight: 300;
		color: rgba(0, 0, 0, 0.87);
	}

	/* .slotRequestStatus >>> .v-input__slot::before {
		border-style: none !important;
	} */

	.v-treeview-node__children {
		background: #eeeeee;
	}
	.v-data-table /deep/ .sticky-header {
		position: sticky;
		top: 0px;
		z-index: 1;
	}

	.v-data-table /deep/ .v-data-table__wrapper {
		margin-top: 0px;
		overflow: unset;
	}

	.v-data-table /deep/ tr:nth-child(2n) {
		background-color: #FAFAFA;
	}

	.v-chip__content {
		font-size: 12px;
	}

	.rowWasEdited {
		border: 2px solid #AB3B7C;
		padding: 2px;
	}

	.uppercase /deep/ input {
		text-transform: uppercase !important;
		margin-top: 10px;
	}

	.notConnectable {
		cursor: not-allowed;
	}

	.connectable {
		cursor: copy;
	}

	/* tbody /deep/ tr:hover {
		background-color: #ab3b7b0b !important;
	} */


</style>

<style>


	.smaller-column {
		width: 5%;
	}

	.v-data-table /deep/ thead tr th {
		background-color: red !important;
	}

	.notMatchingSlot {
		color: red;
	}

</style>

<style lang="sass">
.sdr-chip--active
    background: #AB3B7A
    .v-chip__content
        color: #FFFFFF
</style>

<style>
	.pointer:hover {
		cursor: pointer;
	}
</style>
